import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { DEFAULT_LANGUAGE } from "./config";
import { resources } from "./resources";

if (!i18n.isInitialized) {
  void i18n.use(initReactI18next).init({
    resources: {
      [DEFAULT_LANGUAGE]: resources[DEFAULT_LANGUAGE],
    },
    lng: DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    lowerCaseLng: true,
    interpolation: {
      escapeValue: false,
    },
  });
}

export default i18n;
